import { AbstractSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import { SymbolSubcomponent } from "../symbol-subcomponent";

export class TintDimSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "TintDim";

    constructor(symbol: SymbolSubcomponent, protected dimTint: number = 0x333333) {
        super(symbol);
    }

    public static() {
        super.static();
        this.symbol.tint(0xffffff);
    }

    public winDim() {
        this.symbol.tint(this.dimTint);
        return super.winDim();
    }

    public cycleDim() {
        this.symbol.tint(this.dimTint);
        return super.cycleDim();
    }

    public highlightDim() {
        this.symbol.tint(this.dimTint);
        return super.highlightDim();
    }
}
